import { Lightning, Utils } from "@lightningjs/sdk";
import { Card } from "./Card";
import { Row } from "./Row";
export class HighlightsRow extends Row {
    static _template() {
        return Object.assign(Object.assign({}, super._template()), { h: this.H, Sponsors: {
                x: 1491.362,
                Logo: {
                    w: 142,
                    h: 50,
                    texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 284, 100),
                },
                McDonalds: {
                    x: 155.638,
                    y: 8.5,
                    w: 38,
                    h: 33,
                    texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/sponsor-mcdonalds.svg"), 76, 66),
                },
            } });
    }
    _init() {
        this.headingHeight = 50;
    }
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { h: Card.H_NO_DESC, showDescription: false });
    }
}
HighlightsRow.H = 70 + Card.H_NO_DESC;
export default HighlightsRow;
//# sourceMappingURL=HighlightsRow.js.map